

































import { Component, Prop, Vue } from "vue-property-decorator";
import { Mutation } from "vuex-class";

@Component({})
export default class extends Vue {
  @Mutation("post/clear")
  public clear!: () => void;

  @Prop({ default: "" })
  public value!: string;

  private async created() {
    this.clear();
  }

  public updateValue(value: string) {
    this.$emit("input", value);
  }
}
